import { SafeHarborCalcParams } from './useSafeHarborCalc.interface';

/**
 * Query key factory for the safe-harbor estimate. Extracted so the hook and any
 * invalidations can't drift apart — the params are part of the key because every
 * field changes the resulting figure.
 *
 * Namespaced under `tax` alongside `calculateTaxKeys` and `businessTaxCalcKeys`.
 * The previous bare `['safeHarborCalc', params]` sat outside that namespace,
 * which is why `invalidateCalculatorsForPayment` never reached it: safe harbor
 * nets the same `payment_type=QUARTERLY` rows as self-calculate, so a recorded
 * payment moves its figure, but the invalidation only matched
 * `['tax', 'calculateTax']`.
 */
const safeHarborCalcKeys = {
    all: ['tax', 'safeHarborCalc'] as const,
    byParams: (params?: SafeHarborCalcParams) => ['tax', 'safeHarborCalc', params] as const,
};

export default safeHarborCalcKeys;
